import React, { useEffect } from "react";
import { FormGroup, InputGroup, Card, Button, Dialog, Callout, Icon} from "@blueprintjs/core";
import { Trans, withTranslation } from "react-i18next";
import jwt from 'jwt-decode'

import { updateUser } from "../Home/Home"
import { authenticatedPostFetchWithResult, authenticatedGetFetch } from "../../utils/AuthenticatedFetch";
import { cachedGroups } from "../Supervision/SupervisionMenu";
import { parkLookup } from "../Structure/ParkSelector";
import { deviceLookup } from "../Structure/EquipmentSelector";
import { useNavigate } from "react-router-dom";

export function CheckAuth() {
  const navigate = useNavigate();

  useEffect(() => {
    const tk = localStorage.getItem('token');
    try {
      jwt(tk);
    }
    catch (e) {
      navigate("/signin");
    }
  }, [navigate]);

  return null;
}

export function authHeader() {
  const tk = localStorage.getItem('token');
  if (tk) {
    return { Authorization: `Bearer ${tk}` };
  }
  else
    return {};
}

export function getLoggedUser() {
  const tk = localStorage.getItem('token');
  try {
    const user = jwt(tk)['user'];
    return user;
  }
  catch (e) {
    return '';
  }
}

export function getLoggedUserLevel() {
  const tk = localStorage.getItem('token');
  try {
    const level = jwt(tk)['level'];
    return level + 1; //level is not used now, just use perm_*, level > 0 is enough to navigate, and access button are displayed depending on perm_*
  }
  catch (e) {
    return 0;
  }
}

class Signin extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      btnLoading: false,
      dialogOpen: false,
      permChanged: "notyet"
    };

    this.pwd = undefined;
    this.login = undefined;

    this.submitAuth = this.submitAuth.bind(this);
  };

  async submitAuth() {
    localStorage.clear();
    this.setState({ btnLoading: true });
    if (this.login === undefined || this.login.target.value.length < 3) {
      this.setState({ dialogOpen: true });
    }
    else if (this.pwd === undefined || this.pwd.target.value.length < 3) {
      this.setState({ dialogOpen: true });
    }
    else {
      authenticatedPostFetchWithResult('/login', { login: this.login.target.value, pwd: this.pwd.target.value },
        async (code, authResponse) => {

          if (code === 200 && authResponse !== undefined && authResponse.token !== undefined) {
            const token = authResponse['token'];
            const user = jwt(token);
            localStorage.setItem('token', authResponse['token']);
            localStorage.setItem('user', user['user']);
            localStorage.setItem('userId', user['id']);
            localStorage.setItem('level', user['level']);
            localStorage.setItem('server_settings', JSON.stringify(user['settings']));
            await cachedGroups(true);
            await parkLookup(true);
            await deviceLookup(true);

            const promiseRights = new Promise((res, rej) => {
              authenticatedGetFetch("/rights", (resp) => {
                localStorage.setItem('perm_financial', resp['permFinancial'] === undefined ? false : resp['permFinancial']);
                localStorage.setItem('perm_activity', resp['permActivity'] === undefined ? false : resp['permActivity']);
                localStorage.setItem('perm_custom_report', resp['permCustomReport'] === undefined ? false : resp['permCustomReport']);
                localStorage.setItem('perm_SPV', resp['permSpv'] === undefined ? false : resp['permSpv']);
                localStorage.setItem('perm_tarif', resp['permTarif'] === undefined ? false : resp['permTarif']);
                localStorage.setItem('perm_phonie', resp['permPhonie'] === undefined ? false : resp['permPhonie']);
                localStorage.setItem('perm_bonification', resp['permBonitick'] === undefined ? false : resp['permBonitick']);
                localStorage.setItem('perm_ALPR', resp['permALPR'] === undefined ? false : resp['permALPR']);
                localStorage.setItem('perm_admin', resp['isAdmin'] === undefined ? false : resp['isAdmin']);
                localStorage.setItem('perm_superadmin', resp['isSuperAdmin'] === undefined ? false : resp['isSuperAdmin']);
                localStorage.setItem('perm_home_customisation', resp['permHomeCustomisation'] === undefined ? false : resp['permHomeCustomisation']);
                localStorage.setItem('perm_financial_display', resp['permDisplayFinancial'] === undefined ? false : resp['permDisplayFinancial']);
                localStorage.setItem('perm_activity_display', resp['permDisplayActivity'] === undefined ? false : resp['permDisplayActivity']);
                localStorage.setItem('perm_custom_report_display', resp['permDisplayCustomReport'] === undefined ? false : resp['permDisplayCustomReport']);
                localStorage.setItem('perm_SPV_display', resp['permDisplaySPV'] === undefined ? false : resp['permDisplaySPV']);
                localStorage.setItem('perm_code', !resp['permCode'] ? undefined : JSON.stringify(resp['permCode']));
                localStorage.setItem('perm_extern_access_ctrl', resp['permExternAccessCtrl'] === undefined ? false : resp['permExternAccessCtrl']);
                localStorage.setItem('perm_reservation_display', resp['permResa'] === undefined ? false : resp['permResa']);
                this.setState({ permChanged: new Date(), btnLoading: false }, () => {
                  if (updateUser !== undefined)
                    updateUser();
                  res();
                });
              }, null, null, null, false, { cache: "reload" });
            });

            const promiseEvent = new Promise((res, rej) => {
              authenticatedGetFetch('/eventFiltering', (resp) => {
                const data = resp.map(item => {
                  return {
                    id: item.id,
                    name: item.data[0].name,
                    eventsList: item.data[0].eventsList,
                    equipmentsList: item.data[0].equipmentsList,
                    parksList: item.data[0].parksList,
                  }
                })
                localStorage.setItem('event_filtering', JSON.stringify(data));
                res();
              }, null, null, null, false, { cache: "reload" });
            });

            const promiseALPR = new Promise((res, rej) => {
              authenticatedGetFetch(
                "/ow/dc/version",
                (resp) => {
                  localStorage.setItem("detection_classification", true);
                  res();
                },
                null,
                undefined,
                () => {
                  localStorage.setItem("detection_classification", false);
                  res();
                },
                false,
                { cache: "reload" }
              );
            });

            await Promise.all([promiseRights, promiseEvent, promiseALPR]);
            
            if(localStorage.getItem("perm_SPV") === "true")
              window.location.replace("/ow/view/supervision");
            else
              window.location.replace("/ow/view/home");
          } else {
            this.setState({ dialogOpen: true });
          }
        },
        () => { // bad auth or server unavailable
          this.setState({ dialogOpen: true });
        }
      );
    }
  }

  render() {
    return (
      <div style={{ "paddingTop": "8%", "position": "absolute", "right": "50%" }}>
        <Card style={{ "maxWidth": "600 px" }}>
          <form onSubmit={e => {
            e.preventDefault(); // to avoid reload of the page on submit
            this.submitAuth();
          }}>
            <FormGroup label={<Trans>login</Trans>} labelFor="login-input">
              <InputGroup id="login-input" onChange={(login) => this.login = login} />
            </FormGroup>
            <FormGroup label={<Trans>password</Trans>} labelFor="password-input">
              <InputGroup id="password-input" type="password" onChange={(pwd) => this.pwd = pwd} />
            </FormGroup>
            <Button type="submit" text={<Trans>submit</Trans>} loading={this.state.btnLoading} />
          </form>
        </Card>
        <Dialog
          icon="error"
          title={<Trans>authentication error</Trans>}
          style={{ transition: 'none' }}
          canEscapeKeyClose={true}
          canOutsideClickClose={true}
          isOpen={this.state.dialogOpen}
          onClose={() => {
            this.setState({
              dialogOpen: false,
              btnLoading: false
            })
          }}>
          <Callout intent="danger">
            <p><Trans>the given login/password did not allow you to access this website</Trans></p>
            <p><Trans>check your credentials</Trans></p>
            <div className="flexbox-center">
              <Icon icon="error" size="100" />
            </div>
          </Callout>
        </Dialog>
      </div>
    );
  }
}

export default withTranslation()(Signin)
